import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const mutation = gql`
mutation UpdateUcceIntegration($enable: Boolean!) {
  ucceIntegration(enable: $enable){
    enable
  }
}
`;

function updateUcceIntegration(enable) {
  return apollo.client.mutate({
    mutation,
    variables: {
      enable,
    },
  }).then((res) => res.data.ucceIntegration);
}

export default updateUcceIntegration;
